export default __webpack_public_path__ + "static/media/church_coloured.dbbfb4c4.png";